module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1cZP8"))).then(() => module.bundle.root('lKlEc'));